import { render, staticRenderFns } from "./ContentAbout.vue?vue&type=template&id=6046bf60&"
import script from "./ContentAbout.vue?vue&type=script&lang=js&"
export * from "./ContentAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports